import { Routes } from '~/router/routes'
import { CrmModule, usePermissionChecker } from '~/composables/usePermissionChecker'

const FALLBACK_ROUTES: Array<{ name: Routes; module: CrmModule }> = [
  { name: Routes.SALES_CASES_INDEX, module: CrmModule.SALES_CASES },
  { name: Routes.SALES_SALES_INDEX, module: CrmModule.SALES_SALES },
  { name: Routes.SALES_EVENTS_INDEX, module: CrmModule.SALES_EVENTS },
  { name: Routes.SALES_COMMISSIONS_INDEX, module: CrmModule.SALES_COMMISSIONS },
  { name: Routes.SALES_CONTRACTS_INDEX, module: CrmModule.SALES_DOCUMENTS },
  { name: Routes.OTA_PARTNERS, module: CrmModule.OTA_PARTNERS },
  { name: Routes.OTA_COOPERATION, module: CrmModule.OTA_COOPERATION },
  { name: Routes.OTA_CM_ROOMS_PLANNING, module: CrmModule.OTA_CM },
  { name: Routes.INVOICE_FEE_INVOICES, module: CrmModule.INVOICES },
  { name: Routes.PROPERTIES_REVIEWS, module: CrmModule.PROPERTIES_REVIEWS },
  { name: Routes.PROPERTIES_FRAUDS, module: CrmModule.PROPERTIES_FRAUDS },
  { name: Routes.PROPERTIES_RESERVATIONS, module: CrmModule.PROPERTIES_RESERVATIONS },
  {
    name: Routes.PROPERTIES_CONFIRMED_UNSUCCESSFUL_RESERVATIONS,
    module: CrmModule.PROPERTIES_RECALL,
  },
  { name: Routes.PROPERTIES_MAP, module: CrmModule.PROPERTIES_MAP },
  { name: Routes.USERS_EMPLOYEES, module: CrmModule.EMPLOYEES },
  { name: Routes.SALES_SALESMEN_INDEX, module: CrmModule.SALESMEN },
  { name: Routes.SYSTEM_SITES, module: CrmModule.SYSTEM_SITES },
  { name: Routes.SYSTEM_TIPBOX, module: CrmModule.SYSTEM_TIPBOX },
  { name: Routes.SYSTEM_FEEDBACK, module: CrmModule.SYSTEM_FEEDBACK },
  { name: Routes.BACKOFFICE_CONTACT_PERSON_INDEX, module: CrmModule.CONTACT_PERSONS },
  { name: Routes.PROPERTIES_INDEX, module: CrmModule.PROPERTIES },
]

const P2_NATIVE_ROUTES: ReadonlySet<Routes> = new Set([
  Routes.SALES_CASES_INDEX,
  Routes.SALES_CONTRACTS_INDEX,
  Routes.USERS_EMPLOYEES,
  Routes.BACKOFFICE_CONTACT_PERSON_INDEX,
])

export const resolveDefaultRoute = (): Routes | null => {
  const { canViewEmployeeModule } = usePermissionChecker()

  for (const candidate of FALLBACK_ROUTES) {
    if (P2_NATIVE_ROUTES.has(candidate.name) && canViewEmployeeModule(candidate.module)) {
      return candidate.name
    }
  }

  for (const candidate of FALLBACK_ROUTES) {
    if (canViewEmployeeModule(candidate.module)) {
      return candidate.name
    }
  }

  return null
}
